import React, { useState } from 'react';
import axios from 'axios';
import { db } from '../firebase'; // Ensure Timestamp is imported correctly
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import './ItemForm.css';

const categories = [
  'סת"ם',
  'ריהוט',
  'שוטף',
  'ספרים',
  'אחר',
];

const conditions = [
  'חדש',
  'כמו חדש',
  'משומש במצב טוב',
  'משומש במצב בינוני',
  'משומש במצב גרוע'
];

const regions = [
  'צפון',
  'דרום',
  'מרכז',
  'ירושלים',
  'יהודה ושומרון'
];

const ItemForm = ({ onFormSubmit }) => {
  const [itemName, setItemName] = useState('');
  const [category, setCategory] = useState(categories[0]);
  const [phone, setPhone] = useState('');
  const [nameM, setnameM] = useState('');
  const [condition, setCondition] = useState(conditions[0]);
  const [relevant, setRelevant] = useState(true);
  const [file, setFile] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [description, setDescription] = useState('');
  const [region, setRegion] = useState(regions[0]);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    console.log('File selected:', e.target.files[0]);
  };

  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'ml_default'); // Replace with your actual upload preset name

    try {
      const response = await axios.post(
        `https://api.cloudinary.com/v1_1/dfgw9dqmg/image/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      console.log('Upload response:', response.data);
      return response.data.secure_url;
    } catch (error) {
      console.error('Error uploading to Cloudinary:', error.response ? error.response.data : error.message);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log('Form submitted');

    try {
      const uploadedImageUrl = await uploadToCloudinary(file);
      setImageUrl(uploadedImageUrl);

      await addDoc(collection(db, 'items_giv'), {
        name: itemName,
        category: category,
        condition: condition,
        phone: phone,
        relevant: relevant,
        picture: uploadedImageUrl,
        status: 'unchecked', // Default status
        description: description,
        region: region,
        nameM: nameM,
        uploadDate: Timestamp.fromDate(new Date()) // Set upload date
      });

      console.log('Document added to Firebase');
      alert('המודעה נשלחה לאישור..');
      onFormSubmit();

    } catch (error) {
      console.error('Error adding document:', error);
      alert('שגיאה בתהליך יצירת מודעה.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <form className="form-container" onSubmit={handleSubmit}>
        <h2>הוסף מודעה</h2>
        <h6>שים לב - חלה חובת מילוי כלל השדות בטופס המקוון לפניך </h6>
        <input
          type="text"
          placeholder="שם הפריט"
          value={itemName}
          onChange={(e) => setItemName(e.target.value)}
          required
        />
        <label className='la'>קטגוריה</label>
        <select value={category} onChange={(e) => setCategory(e.target.value)} required>
          {categories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
        <label className='la'> מצב המוצר</label>
        <select value={condition} onChange={(e) => setCondition(e.target.value)} required>
          {conditions.map((cond) => (
            <option key={cond} value={cond}>
              {cond}
            </option>
          ))}
        </select>
        <label className='la'> איזור</label>
        <select value={region} onChange={(e) => setRegion(e.target.value)} required>
          {regions.map((reg) => (
            <option key={reg} value={reg}>
              {reg}
            </option>
          ))}
        </select>
        <input
          type="text"
          placeholder="טלפון מעלה המודעה"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />

        <input
          type="text"
          placeholder="שם מעלה המודעה"
          value={nameM}
          onChange={(e) => setnameM(e.target.value)}
          required
        />

        <textarea
          style={{ width: '297px' }}
          placeholder="תיאור המוצר"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
          rows={3}

        />

        <>העלאת תמונת המוצר </>
        <input type="file" placeholder='בחר תמונה' onChange={handleFileChange} required />
        <button type="submit" disabled={loading}>
          {loading ? 'מעלה...' : 'הוסף חפץ'}
        </button>
      </form>

      {/* {imageUrl && (
        <div>
          <h3>תמונה של המוצר :</h3>
          <img src={imageUrl} alt="הוסף תמונה " className="item-image" style={{ width: '500px', height: '500px' }} />
        </div>
      )} */}
    </div>
  );
};

export default ItemForm;
